import React, { useState } from "react";
import axios from "axios";
import { FaTimes } from "react-icons/fa";
import AdminDocumentUploader from "../AdminDocumentUploader";

export default function AdminCustomVisaModal({ onClose, onCreated }) {
  const [formData, setFormData] = useState({
    userEmail: "",
    country: "",
    visaType: "",
    amount: "",
    status: "approved"
  });
  const [loading, setLoading] = useState(false);
  const [newBookingId, setNewBookingId] = useState(null);

  const BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await axios.post(`${BASE}/api/visa/admin/custom-application`, formData, { withCredentials: true });
      if (res.data.success) {
        setNewBookingId(res.data.data._id);
        alert("Custom Visa application created successfully! You can now upload documents if needed.");
      }
    } catch (error) {
      alert(error.response?.data?.error || "Failed to create custom application");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto relative p-6">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800">
          <FaTimes size={20} />
        </button>
        <h2 className="text-xl font-bold mb-4">Create Custom Visa Application</h2>

        {!newBookingId ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">User Email</label>
              <input required type="email" name="userEmail" value={formData.userEmail} onChange={handleChange} className="w-full border p-2 rounded" placeholder="User's registered email" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Country</label>
              <input required type="text" name="country" value={formData.country} onChange={handleChange} className="w-full border p-2 rounded" placeholder="e.g. Dubai" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Visa Type</label>
              <input required type="text" name="visaType" value={formData.visaType} onChange={handleChange} className="w-full border p-2 rounded" placeholder="e.g. 30 Days Tourist Visa" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Total Amount (₹)</label>
              <input required type="number" name="amount" value={formData.amount} onChange={handleChange} className="w-full border p-2 rounded" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Status</label>
              <select name="status" value={formData.status} onChange={handleChange} className="w-full border p-2 rounded">
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
            </div>
            <button type="submit" disabled={loading} className="w-full bg-blue-600 text-white p-2 rounded font-bold hover:bg-blue-700">
              {loading ? "Creating..." : "Create Application"}
            </button>
          </form>
        ) : (
          <div className="space-y-4">
            <div className="p-4 bg-green-50 text-green-800 rounded">
              Visa Application Created! ID: {newBookingId}
            </div>
            <AdminDocumentUploader
              type="visa"
              bookingId={newBookingId}
              onUploadSuccess={(docs) => {}}
            />
            <button onClick={() => { onCreated(); onClose(); }} className="w-full bg-gray-200 text-gray-800 p-2 rounded font-bold hover:bg-gray-300 mt-4">
              Finish & Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
